import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { HexTextModule } from "@hex/angular/text";
import { SharedPipesModule } from "../../../pipes/pipes.module";

import { InlineLabeledTextComponent } from "./inline-labeled-text.component";

@NgModule({
    imports: [
        CommonModule,
        HexTextModule,
        SharedPipesModule,
    ],
    exports: [
        InlineLabeledTextComponent,
    ],
    declarations: [
        InlineLabeledTextComponent,
    ],
    providers: [],
})
export class TextPatternsModule {
}
